if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('#cart-drawer');
      this.sizeConversion();
      this.updateVariantJson();
      
    }
  
    updateVariantJson() {
    }
  
  

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      const preOrderAgree = this.querySelector('#pre-order__agree');
      if(preOrderAgree && preOrderAgree.checked !== true) {
        preOrderAgree.parentNode.classList.add('darker');
        var scrollDiv = preOrderAgree.offsetTop;
        window.scrollTo({ top: scrollDiv - 80, behavior: 'smooth'});
        return false;
      }
      

      const submitButton = this.querySelector('[type="submit"]');
      const floatingButton = this.querySelector('#mobile-floating-add-button');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
      
      floatingButton.setAttribute('disabled',true);
      floatingButton.classList.add('loading');
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      
      const propertyInputs = document.querySelectorAll('variant-radios .property-input');
      propertyInputs.forEach(property => {
        formData.append(property.getAttribute('name'),property.value);
      });
      
      config.body = formData;
     
            

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        this.renderContents(response);
        
        
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.removeAttribute('disabled');
        submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      
        floatingButton.classList.remove('loading');
        floatingButton.removeAttribute('aria-disabled');
        floatingButton.removeAttribute('disabled');
        floatingButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      
      
        document.querySelector('[data-drawer-target]').classList.add('is-visible');
        document.querySelector('html').classList.add('overflow-hidden');
      
        theme.insurance();
    });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  }

  sizeConversion() {
    const conversionLinks = document.querySelectorAll('.size-conversion__link');
    const sizeValues = document.querySelectorAll('.size-value');
    
    const allSizes = {
      mens: {
        eu: [39,40,41,42,43,44,45,46,47],
        us: [6,7,8,9,10,11,12,13,14]
      },
      womens: {
        eu: [36,37,38,39,40,41,42,43],
        us: [5,6,7,8,9,10,11,12]
      }
    };
    var sizes = allSizes.womens;

    if(window.productJSON.type.indexOf('Mens') > -1) {
      sizes = allSizes.mens;
    }
    if(conversionLinks.length == 0) return;

    sizes.eu.forEach((size,s) => {
      document.querySelectorAll('.product-form__input[data-option="Size"] .variant-radio').forEach((el,i) => {
        if(el.getAttribute('data-value') == size) {
          el.querySelector('.size-value').setAttribute('data-us',sizes.us[s]);
        }
      });
    });
    

    conversionLinks.forEach((link) => {
      link.addEventListener('click',(e) => {
        conversionLinks.forEach((allLinks) => {
          allLinks.classList.remove('active');
        });
        link.classList.add('active');
        const attr = link.getAttribute('data-country') == 'us' ? 'data-us' : 'data-eu';
        sizeValues.forEach((sv) => {
          sv.textContent = sv.getAttribute(attr);
        });
        
        let sizeType = document.querySelector('.size-conversion__link.active').innerText.toLowerCase();
        let sizeNumber = document.querySelector('fieldset[data-option="Size"] input[type=radio]:checked + label span').getAttribute(`data-${sizeType}`);
        if(!!document.querySelector('.cwpreorder_text a span')) {
          document.querySelector('.cwpreorder_text a span').innerText = sizeNumber;
        }
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.drawer__content',
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
  }
  });
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    
    this.addEventListener('change', this.onVariantChange);
	this.selects = document.querySelectorAll(".select__select");
    this.selects.forEach(function (select) {
      select.addEventListener("change", _this.onSelectChange);
    });
    
    this.currentVariant = window.initialVariant;
    window.currentVariant = this.currentVariant;
    this.preOrder();
    this.updateBisVariant();
    
    document.querySelector('.product-form__submit').classList.remove('loading');
    document.querySelector('.product-form__submit .loading-overlay__spinner').classList.add('hidden');
    
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    
    if(event && event.target.name == 'Color') {
//       this.updateContent(event.target.getAttribute('data-url'));
      window.location.href = event.target.getAttribute('data-url');
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateAddButton();
      this.updatePrice();
      this.preOrder();
      this.updateWishlistButton();
      this.updateBisVariant();
      
//       this.updateShareUrl();
    }
    
    
  }
  
  updateBisVariant() {
    document.getElementById('bis--id').value = this.currentVariant.id;
    console.log(this.currentVariant.id,document.getElementById('bis--id').value);
  }
  

  
  startLoading() {
    document.querySelector(".product .loading-overlay").classList.remove("hidden");
  }

  finishLoading() {
    document.querySelector(".product .loading-overlay").classList.add("hidden");
  }
  
  updateWishlistButton() {
    fetch(`${this.currentVariant.productUrl}?section_id=wishlist-button-product`)
    .then(response => { 
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");      
      const buttonWrapper = document.querySelector('.wishlist-button-product__wrapper');
      buttonWrapper.innerHTML = doc.querySelector('.shopify-section').innerHTML;
    });
  }
  
  preOrder() {
    const productElement = document.querySelector('.product');
    const productForm  = document.querySelector('variant-radios');
    const inStockShipping = document.querySelector('.in-stock--shipping');
    const preOrderShipping = document.querySelector('.pre-order--shipping');
    const preOrderShippingText = document.querySelectorAll('.pre-order-text');
    const klaviyoBisWrappers = document.querySelectorAll('.klaviyo-bis-wrapper');
    const preOrderInput = document.querySelector('.pre-order--property');
    const preOrderCheckbox = document.querySelector('.pre-order__disclaimer');
    const preOrderCheckboxWrapper = document.querySelector('.pre-order_disclaimer--wrapper');
    const productFormButtons = document.querySelector('.product-form__buttons');
    console.log(this.currentVariant)

    if(this.currentVariant.preOrder && this.currentVariant.inventoryQuantity <= 0) {
      preOrderShippingText.forEach(preText => {
        preText.textContent = this.currentVariant.preOrder;
      });
      inStockShipping.style.display = 'none';
//       preOrderShipping.style.display = 'block';
//       klaviyoBisWrappers.style.display = 'block';
      klaviyoBisWrappers.forEach(klaviyoBis => {
        klaviyoBis.style.display = 'block';
      });
      preOrderInput.value = this.currentVariant.preOrder;
      productForm.appendChild(preOrderInput);
      preOrderCheckboxWrapper.appendChild(preOrderCheckbox);
      preOrderCheckbox.classList.remove('hidden');
      this.toggleAddButton(false, window.variantStrings.preOrder, false);
      
var PreOrderTitle = this.currentVariant.title;
var PreOrderCW = document.querySelector('.preorder_cw_max');
var numberPattern = /\d+/;
var match = PreOrderTitle.match(numberPattern);
var productCategory = document.querySelector('#product_collection_cw').value;

if (match) {
  var extractedNumber = match[0];
  var sizeType = document.querySelector('.size-conversion__link.active').innerText.toLowerCase();
  var extractedNumberRegion = document.querySelector('fieldset[data-option="Size"] input[type=radio]:checked + label span').getAttribute(`data-${sizeType}`);
} else {
  var extractedNumber = 'No Size';
  var extractedNumberRegion = 'No Size';
}
if(productCategory == 'women') {
var productLinkFilter = 'best-sellers-women';
} else {
var productLinkFilter = 'best-sellers-men';
}
if (PreOrderCW) {
  PreOrderCW.innerHTML = '<div class="cwpreorder_text">Pre-Order or <a href="/collections/' + productLinkFilter +'?filter.v.option.size=' + extractedNumber + '&filter.v.availability=1&sort_by=best-selling">Discover available sandals in <span>' + extractedNumberRegion + '</span> now ➜</a></div>';
}
      
    } else if(!this.currentVariant.preOrder && !this.currentVariant.available) {
      this.toggleAddButton(true,window.variantStrings.soldOut);
      inStockShipping.style.display = 'block';
      preOrderShipping.style.display = 'none';
      klaviyoBisWrappers.forEach(klaviyoBis => {
        klaviyoBis.style.display = 'none';
      });
      productElement.appendChild(preOrderInput);
      preOrderCheckbox.classList.add('hidden');
      productElement.appendChild(preOrderCheckbox);
    } 
    
    else {
      inStockShipping.style.display = 'block';
      preOrderShipping.style.display = 'none';
      klaviyoBisWrappers.forEach(klaviyoBis => {
        klaviyoBis.style.display = 'none';
      });
      productElement.appendChild(preOrderInput);
      preOrderCheckbox.classList.add('hidden');
      productElement.appendChild(preOrderCheckbox);
      this.toggleAddButton(false, window.variantStrings.addToCart, false);
      var PreOrderCW = document.querySelector('.preorder_cw_max');
if (PreOrderCW) {
  PreOrderCW.innerHTML = '<div class="cwpreorder_text stocknow">In Stock Now - Ready To Ship</div>';
}
    }

if(this.currentVariant.inventoryQuantity >= 1 && this.currentVariant.inventoryQuantity < 5  ) {
   
var stockStatusCwMax = document.querySelector('.stock_status_cw_max');
if (stockStatusCwMax) {
  stockStatusCwMax.innerHTML = '<div class="low_stock">Low Stock - Ready To Ship</div>';
}
var PreOrderCW = document.querySelector('.preorder_cw_max');
if (PreOrderCW) {
  PreOrderCW.innerHTML = '';
}
  
} else {
var stockStatusCwMax = document.querySelector('.stock_status_cw_max');
if (stockStatusCwMax) {
  stockStatusCwMax.innerHTML = '';
}  
}
  }
  
  updatePrice() {
    return false;
    const priceEl = document.querySelector('.product__info-wrapper .price .price-item--regular');
    if(!priceEl) return;
    priceEl.innerHTML = Shopify.formatMoney(this.currentVariant.price).replace('.00','');
  }
  
  updateContent(url) {
    const _this = this;

    const currentUrl = window.location.href;
    const newUrl = url ? url : this.currentVariant.productUrl;

    if (currentUrl.indexOf(newUrl) != -1) return false;
    
    _this.startLoading();
    
    const elementsToUpdate = [
      ".product__media-wrapper",
      ".product-media-modal__content",
      ".product__json",
      ".waitlist-popup--bis",
      ".product__price-wrapper"
    ];
    
    fetch(newUrl)
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      elementsToUpdate.forEach((element, i) => {
        var el = document.querySelector(element);
        if(el) {
          el.innerHTML = doc.querySelector(element).innerHTML;
        } else {
          console.log(element);
        }
      });
      const newJson = JSON.parse(doc.querySelector('#productVariantsJson').innerHTML);
//       _this.updateJson(newJson);

      _this.updateBisVariant();
//       this.updateBisForm();
      
      _this.finishLoading();
    })
    .catch(function (err) {
      // There was an error
      _this.finishLoading();
    });
  }
  
  updateJson(json) {
    window.productJSON.variants.forEach(oldVariant => {
      json.forEach(newVariant => {
        if(newVariant.id !== oldVariant.id) return;
        oldVariant.inventoryQuantity = newVariant.inventoryQuantity;
        oldVariant.preOrder = newVariant.preOrder;
      });
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
  
  updateCurrentOptions() {
    if (this.useSelects) return;
    let _this = this;
    this.options.forEach(function (option, o) {
      const optionIndexValue = document.querySelector(`variant-radios .product-form__input[data-option-index="${o}"] .current-value`);
      if(optionIndexValue) {
        optionIndexValue.textContent = option;
      }
    });
  }
  
  updateAddButton() {
   
    if(this.currentVariant.available) {
      this.toggleAddButton(false, window.variantStrings.addToCart, true);
    } 
    if(this.currentVariant.preOrder) {
      this.toggleAddButton(false,window.variantStrings.preOrder,true);
    }
    document.querySelector('.product-form__submit').classList.remove('loading');
  }
  

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    window.currentVariant = this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL(url = false) {
    const newUrl = url ? url : this.currentVariant.productUrl + '?variant=' + this.currentVariant.id;
    if (!this.currentVariant && !url) return;
    window.history.replaceState(
      {},
      "",
      `${newUrl}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }  

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    
    const floatingButton = productForm.querySelector('#mobile-floating-add-button');
    const floatingButtonText = floatingButton.querySelector('span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      floatingButton.setAttribute('disabled','disabled');
      if (text) {
        addButtonText.textContent = text;
        floatingButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      floatingButton.removeAttribute('disabled');
      addButtonText.textContent = text;
      floatingButtonText.textContent = text;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || window.productJSON.variants;
    return this.variantData;
  }
}


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const checkedRadios = document.querySelectorAll(
      ".variant-radio input:checked"
    );
    const values = Array.from(checkedRadios, (radio) => radio.value);
    this.options = Array.from(
      this.querySelectorAll(".variant-radio input:checked"),
      (input) => input.value
    );
    this.updateCurrentOptions();
  }
}


function productAccordionButtons() {
  if(!isMobile()) return;
  const accordionButtons = document.querySelectorAll('.product-accordion__button');
  const accordionTabs = document.querySelectorAll('.product-single__description--content');
  
  accordionTabs.forEach((accordionTab,i) => {
    if(i === 0) return true;
    accordionTab.style.display = 'none';
  });
  
  accordionButtons.forEach(accordionButton => {
    accordionButton.addEventListener('click', e => {
      e.preventDefault();
      if(!isMobile()) return;
      const button = e.target;
      const buttonTab = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if(expanded) {
        button.setAttribute('aria-expanded','false');
        buttonTab.style.display = 'none';
      } else {
        button.setAttribute('aria-expanded','true');
        buttonTab.style.display = 'block';
      }
    });
  });
}

function checkGender(tags) {
  let gender = false;
  if(tags.indexOf('unisex') > -1 || tags.indexOf('UNISEX') > -1) {
    gender = 'UNISEX';
    return gender;
  }
  tags.forEach(tag => {
    const tagCase = tag.toUpperCase();
    if(tagCase === 'WOMENS') {
      gender = tagCase;
    } 
    else if(tagCase === 'MENS') {
      gender = tagCase;
    }
  });
  return gender;
}

function updateJson(url) {
  fetch(url)
  .then(response => response.json())
  .then(data => {
    window.productJSON.variants.forEach(oldVariant => {
      data.forEach(newVariant => {
        if(oldVariant.id !== newVariant.id) return;
        oldVariant.inventoryQuantity = newVariant.inventoryQuantity;
        oldVariant.preOrder = newVariant.preOrder;
      });
    });
    
  })
  .catch(error => console.log(error));

}

/* Set it all up */
(function() {
  const titleSplit = productJSON.title.split(' | ');
  if(titleSplit.length <= 1) {
    customElements.define("variant-selects", VariantSelects);
    customElements.define("variant-radios", VariantRadios);
    return false;
  }
  const addButton = document.querySelector('.product-form__submit');
  addButton.classList.add('loading');
//   addButton.textContent = '';
  const productTitle = titleSplit[0].trim();
  const productColor = titleSplit[1].trim();
  const productTitleSplitSpaces = productTitle.split(" ");
  // Quote the title: unquoted, `title:` only applies to the first word, so models
  // starting with "The" (The Good Shepherd, The Original, The Wayfarer...) found nothing.
  const titleQuery = encodeURIComponent(`title:"${productTitle.replace(/"/g, '')}"`);
  const searchUrl = `/search?q=${titleQuery}&type=product&view=api`;
  const variantMetafieldsUrl = `/search?q=${titleQuery}%20tag:${window.productGender}&type=product&view=variant-metafields`;
  const results = [];
  results.push(productColor);
  const productVariantsJsonElement = document.querySelector(
    "#productVariantsJson"
  );
  const productVariantsJson = productJSON.variants;
  const colorSelect = document.querySelector(".select__select--color");
  const colorButton = document.querySelector(
    '.product-form__input[data-option="Color"] .variant-radios--wrapper'
  );
  let colorsFound = [];

  productVariantsJson.forEach((v) => {
    v.productUrl = "/products/" + productJSON.handle;
  });

  fetch(searchUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const items = JSON.parse(responseText);
	  let hasCore = false;
      let hasSecondary = false;
    
      items.forEach((item, i) => {
		
		const itemTitle = item.title;
        
        // ========== OPTIMIZED IMAGE HANDLING START ==========
        let itemImage = item.featured_image;

        let itemThirdImage = ( item.images && item.images[2] ) ? item.images[2] : '';

        if (itemImage) {
          // Remove existing size parameters
          itemImage = itemImage.replace(/(_\d+x\d*|_\d*x\d+|_\d+x|_x\d+|_pico|_icon|_thumb|_small|_compact|_medium|_large|_grande|_original|_1024x1024|_2048x2048|_master)/g, '');
          
          // Add optimized size (300x300 for 156px display at 2x = good quality)
          const extension = itemImage.match(/\.(jpg|jpeg|png|webp)/i);
          if (extension) {
            itemImage = itemImage.replace(extension[0], '_200x200' + extension[0]);
          }
        }

        if (itemThirdImage) {
          // Remove existing size parameters
          itemThirdImage = itemThirdImage.replace(/(_\d+x\d*|_\d*x\d+|_\d+x|_x\d+|_pico|_icon|_thumb|_small|_compact|_medium|_large|_grande|_original|_1024x1024|_2048x2048|_master)/g, '');
          
          // Add optimized size (300x300 for 156px display at 2x = good quality)
          const thirdExtension = itemThirdImage.match(/\.(jpg|jpeg|png|webp)/i);
          if (thirdExtension) {
            itemThirdImage = itemThirdImage.replace(thirdExtension[0], '_200x200' + thirdExtension[0]);
          }
        }
        // ========== OPTIMIZED IMAGE HANDLING END ==========
        
        console.log(window.productGender, checkGender(item.tags));
        if(window.productGender != checkGender(item.tags)) return;
        

        const itemPrefix = item.title.split(' | ')[0].trim().toUpperCase();
        const productPrefix = productTitle.toUpperCase();
        if(itemPrefix !== productPrefix) return;

        console.log(item);
        console.log(itemImage);
		if(itemTitle.indexOf(productTitle) == -1) return;

        let color = item.title.split(' | ')[1];
        if(window.swatchColors.indexOf(color) === -1) return;
        
        if (color) {
          color = color.trim();
        }
        if (colorsFound.indexOf(color) > -1) return;
        colorsFound.push(color);


        const itemVariants = item.variants;

        itemVariants.forEach((v) => {
          v.productUrl = "/products/" + item.handle;
        });

        const colorFieldset = document.querySelector(
          'fieldset[data-option="Color"]'
        );
        const checked = productColor === color ? "checked" : "";

		
        if (colorButton) {
          const swatch = document.createElement("div");
          swatch.classList.add("variant-radio");

          // ========== OPTIMIZED SWATCH HTML START ==========
          // Create 2x version for retina displays
          let itemImage2x = itemImage.replace('_200x200', '_300x300');

          let itemThirdImage2x = itemThirdImage && itemThirdImage.replace('_200x200', '_300x300');
          if(window.location.pathname.includes('barnabas-black') && color === 'Black'){
            itemImage = 'https://sfycdn.speedsize.com/f42da903-9441-401c-abe7-28fdbcc3ca1c/https://jerusalemsandals.com/cdn/shop/products/barnabas-molded-black-slip-on-jrslm-541078_2x_f17be955-4bcd-4ea5-b82e-29c82debf098_200x.jpg?v=1597283048';
            itemImage2x = 'https://sfycdn.speedsize.com/f42da903-9441-401c-abe7-28fdbcc3ca1c/https://jerusalemsandals.com/cdn/shop/products/barnabas-molded-black-slip-on-jrslm-541078_2x_f17be955-4bcd-4ea5-b82e-29c82debf098_300x.jpg?v=1597283048'
          }
          
          swatch.innerHTML = `<input type="radio" ${checked} id="template-product__main-Color-${i + 1}" name="Color" value="${color}" data-color-handle="${color}" data-url="/products/${item.handle}">
          <label data-tooltip="${color}" for="template-product__main-Color-${i + 1}">
            <span class="img_swatch">
              <img src="${itemImage}" 
                   srcset="${itemImage} 1x, ${itemImage2x} 2x"
                   alt="${color}"
                   loading="eager"
                   fetchpriority="high"
                   width="156"
                   height="156">

              <img src="${itemThirdImage}" 
                   srcset="${itemThirdImage} 1x, ${itemThirdImage2x} 2x"
                   alt="${color}"
                   loading="eager"
                   fetchpriority="high"
                   width="156"
                   style="display: none;"
                   height="156">
            </span>
            <span class="visually-hidden">${color}</span>
          </label>`;
          // ========== OPTIMIZED SWATCH HTML END ==========
        
         colorButton.appendChild(swatch);
    
        }

        if (colorSelect) {
          const option = document.createElement("option");
          option.value = color;
          option.textContent = color;
          colorSelect.appendChild(option);
        }

		if(window.productJSON.id != item.id) {
          productVariantsJson.push(...itemVariants);
          window.productJSON.variants.push(...itemVariants);
		}

        results.push(color);
      });

	  if(hasSecondary) {
        document.querySelector('.colors--secondary__wrapper').classList.remove('hidden');
        
      }

      customElements.define("variant-selects", VariantSelects);
      customElements.define("variant-radios", VariantRadios);
    
      updateJson(variantMetafieldsUrl);
      
      if(!window.currentVariant) return;
    });
  
  const preOrderCheckbox = document.querySelector('#pre-order__agree');
  preOrderCheckbox.addEventListener('change',e => {
    if(e.target.checked) {
     e.target.parentNode.classList.remove('darker'); 
    }
  });
  
  productAccordionButtons();
  
})();